import { render, staticRenderFns } from "./QueueRecordCountTable.vue?vue&type=template&id=021a191e&lang=true&"
import script from "./QueueRecordCountTable.vue?vue&type=script&lang=js&"
export * from "./QueueRecordCountTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports